import React from 'react';
import { useNavigate } from "react-router-dom";
import img from "../../resources/logo.webp"

export const AdminSettings = () => {
    const [allOk, setAllOk] = React.useState(null);
    const [oldPassword, seOldPassword] = React.useState("");
    const [newPassword, setNewPassword] = React.useState("");
    const [newRepeated, setNewRepeated] = React.useState("");
    const [message, setMessage] = React.useState("");
    const navigate = useNavigate();

    const HandleClick = () => {
      if (oldPassword.trim().length !== 0 && newPassword.trim().length !== 0 && newRepeated.trim().length !== 0) {
        if (newPassword !== newRepeated) {
          setMessage("Nove lozinke se ne poklapaju");
        } else if (oldPassword === newPassword) {
          setMessage("Stara i Nova lozinka su iste");
        } else {
          setMessage("Lozinka uspešno promenjena");
          setAllOk(true)
          return;
        }

        setAllOk(false);
      } else {
        setAllOk(false);
        setMessage("Sva polja moraju biti popunjena")
      }
    }

    return (
      <div className="barber-zajednica-admin-page">
        <div className="barber-zajednica-admin-background"></div>
        <h1>Promeni lozinku</h1>
        <input
          style={{marginBottom: "30px"}}
          type="password"
          placeholder={'Unesi staru lozinku'}
          className={"barber-zajednica-input-password"}
          value={oldPassword}
          onChange={(e) => seOldPassword(e.target.value)}
        />
        <input
          style={{marginBottom: "30px"}}
          type="password"
          placeholder={'Unesi novu lozinku'}
          className={"barber-zajednica-input-password"}
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        <input
          type="password"
          placeholder={'Potvrdi novu lozinku'}
          className={"barber-zajednica-input-password"}
          value={newRepeated}
          onChange={(e) => setNewRepeated(e.target.value)}
        />
        <div style={{marginTop: "40px", color: allOk ? "#be9455" : "rgb(163, 38, 38)"}}>
          {message}
        </div>
        <button className="barber-zajednica-login-button" onClick={HandleClick}>
          Promeni lozinku
        </button>
        <div className="barber-zajednica-admin-logo">
          <img src={img} alt="Logo" />
        </div>
      </div>
    );
}